import { useWebViewRouter } from '@/hooks/useWebViewRouter';
import { FormattedMessage } from 'react-intl';

const SkipButton = () => {
  const { direct } = useWebViewRouter();

  return (
    <button
      className="rounded-[20px] bg-[#f2f2f2] w-[355px] h-[66px] flex flex-row justify-center items-center cursor-pointer"
      onClick={() => direct('/photocard')}
    >
      <span className="text-[18px] leading-9 font-bold text-black">
        <FormattedMessage id="skip" defaultMessage="Skip" />
      </span>
    </button>
  );
};

export default SkipButton;
